import React from "react";
import HCDashboard from "./views/Dashboard/HumanCapital/HCDashboard";

const Breadcrumbs = React.lazy(() => import("./views/Base/Breadcrumbs"));
const Cards = React.lazy(() => import("./views/Base/Cards"));
const Carousels = React.lazy(() => import("./views/Base/Carousels"));
const Collapses = React.lazy(() => import("./views/Base/Collapses"));
const Dropdowns = React.lazy(() => import("./views/Base/Dropdowns"));
const Forms = React.lazy(() => import("./views/Base/Forms"));
const Jumbotrons = React.lazy(() => import("./views/Base/Jumbotrons"));
const ListGroups = React.lazy(() => import("./views/Base/ListGroups"));
const Navbars = React.lazy(() => import("./views/Base/Navbars"));
const Navs = React.lazy(() => import("./views/Base/Navs"));
const Paginations = React.lazy(() => import("./views/Base/Paginations"));
const Popovers = React.lazy(() => import("./views/Base/Popovers"));
const ProgressBar = React.lazy(() => import("./views/Base/ProgressBar"));
const Switches = React.lazy(() => import("./views/Base/Switches"));
const Tables = React.lazy(() => import("./views/Base/Tables"));
const Tabs = React.lazy(() => import("./views/Base/Tabs"));
const Tooltips = React.lazy(() => import("./views/Base/Tooltips"));
const BrandButtons = React.lazy(() => import("./views/Buttons/BrandButtons"));
const ButtonDropdowns = React.lazy(() =>
  import("./views/Buttons/ButtonDropdowns")
);
const ButtonGroups = React.lazy(() => import("./views/Buttons/ButtonGroups"));
const Buttons = React.lazy(() => import("./views/Buttons/Buttons"));
const Charts = React.lazy(() => import("./views/Charts"));
const Dashboard = React.lazy(() => import("./views/Dashboard"));
const CoreUIIcons = React.lazy(() => import("./views/Icons/CoreUIIcons"));
const Flags = React.lazy(() => import("./views/Icons/Flags"));
const FontAwesome = React.lazy(() => import("./views/Icons/FontAwesome"));
const SimpleLineIcons = React.lazy(() =>
  import("./views/Icons/SimpleLineIcons")
);
const Alerts = React.lazy(() => import("./views/Notifications/Alerts"));
const Badges = React.lazy(() => import("./views/Notifications/Badges"));
const Modals = React.lazy(() => import("./views/Notifications/Modals"));
const Colors = React.lazy(() => import("./views/Theme/Colors"));
const Typography = React.lazy(() => import("./views/Theme/Typography"));
const Widgets = React.lazy(() => import("./views/Widgets/Widgets"));
const Users = React.lazy(() => import("./views/Users/Users"));
const User = React.lazy(() => import("./views/Users/User"));
const WelcomePage = React.lazy(() => import("./views/Pages/Welcome/Welcome"));
const FirstPage = React.lazy(() => import("./views/Pages/Welcome/StartPage"));
const BusinessDashboard = React.lazy(() =>
  import("./views/Dashboard/Business/BusinessDashboard")
);
const HumanCapitalDashboard = React.lazy(() =>
  import("./views/Dashboard/HumanCapital/HCDashboard")
);
const FinanceDashboard = React.lazy(() =>
  import("./views/Dashboard/Finance/FinanceDashboard")
);
const CaseControl = React.lazy(() => import("./views/CaseControl/CaseControl"));
const CaseBoard = React.lazy(() => import("./views/CaseBoard/CaseBoard"));
const CasePage = React.lazy(() => import("./views/CasePage/CasePage"));
const CaseNew = React.lazy(() => import("./views/CasePage/CaseNew/CaseNew"));
const CaseProspect = React.lazy(() =>
  import("./views/CasePage/CaseProspect/CaseProspect")
);
const CaseList = React.lazy(() =>
  import("./views/CaseControl/CaseList/CaseList")
);
const ProspectList = React.lazy(() =>
  import("./views/CaseControl/ProspectList/ProspectList")
);
const EmployeeProfile = React.lazy(() =>
  import("./views/EmployeeProfile/EmployeeProfile")
);
const NotesView = React.lazy(() =>
  import("./views/EmployeeProfile/Page/NotesView")
);
const UserAdminPage = React.lazy(() =>
  import("./views/Administrator/Users/Users")
);

const CaseTypeAdminPage = React.lazy(() =>
  import("./views/Administrator/CaseTypeMaster/CaseTypeMaster")
);

const CaseStatusAdminPage = React.lazy(() =>
  import("./views/Administrator/CaseStatusMaster/CaseStatusMaster")
);

const LeaveRequstAdminPage = React.lazy(() =>
  import("./views/Administrator/LeaveRequestCategory/LeaveRequestCategory")
);
const TimesheetInput = React.lazy(() => import("./views/Timesheet/Timesheet"));
const TimesheetSearch = React.lazy(() =>
  import("./views/Timesheet/TimesheetSearch")
);
const TimesheetInputRoutine = React.lazy(() =>
  import("./views/TimesheetRoutine/Timesheet")
);
const TimesheetRoutineUpdate = React.lazy(() =>
  import("./views/TimesheetRoutine/TimesheetUpdate/TimesheetDataEntry")
);
const TimesheetSearchRoutine = React.lazy(() =>
  import("./views/TimesheetRoutine/TimesheetSearch")
);

const PracticeMaster = React.lazy(() =>
  import("./views/Administrator/PracticesMaster/PracticesMaster")
);
const SectorMaster = React.lazy(() =>
  import("./views/Administrator/SectorsMaster/SectorsMaster")
);
const VendorMaster = React.lazy(() =>
  import("./views/Administrator/VendorMaster/VendorMaster")
);
const DocumentTypeMaster = React.lazy(() =>
  import("./views/Administrator/DocumentTypesMaster/DocumentTypesMaster")
);
const CaseFlagMaster = React.lazy(() =>
  import("./views/Administrator/CaseFlagMaster/CaseFlagMaster")
);
const CaseUpdateTemplateMaster = React.lazy(() =>
  import("./views/Administrator/CaseUpdateTemplate/CaseUpdateTemplate")
);
const CaseSeeDocument = React.lazy(() =>
  import("./views/CasePage/CaseSeeDocument/CaseSeeDocument")
);
const MedicalReimbursement = React.lazy(() =>
  import("./views/Administrator/MedicalReimbursement/MedicalReimbursement")
);
const ReimbursementOverride = React.lazy(() =>
  import("./views/HCAdmin/Override/ReimbursementOverride")
);
const MedicalReimbursementPlanDetail = React.lazy(() =>
  import(
    "./views/Administrator/MedicalReimbursement/MedicalReimbursementPlanDetail"
  )
);
const ApprovalSystem = React.lazy(() =>
  import("./views/Administrator/ApprovalSystemMaster/ApprovalSystemMaster")
);
const GeneralApprovalSystem = React.lazy(() =>
  import("./views/Administrator/GeneralApprovalsSystem/Approvals")
);
const MeetingLog = React.lazy(() => import("./views/MeetingLog/Meetinglog"));
const PotentialClient = React.lazy(() =>
  import("./views/MeetingLog/PotentialClient")
);
const CaseUpdate = React.lazy(() =>
  import("./views/CasePage/CaseUpdate/CaseUpdate")
);
const CaseUpdateProspect = React.lazy(() =>
  import("./views/CasePage/CaseProspect/CaseUpdate/CaseUpdateProspect")
);
const TimesheetUpdate = React.lazy(() =>
  import("./views/Timesheet/TimesheetUpdate/TimesheetDataEntry")
);
const AccountReceivable = React.lazy(() =>
  import("./views/Dashboard/AccountReceivable/ListAccountReceivable")
);
const TimesheetsView = React.lazy(() =>
  import("./views/Timesheet/TimesheetsView/TimesheetsView")
);
const ARInput = React.lazy(() => import("./views/Finance/AR/ARInput"));
const ARList = React.lazy(() => import("./views/Finance/AR/ARList"));
const ARUpdate = React.lazy(() => import("./views/Finance/AR/ARUpdateQuery"));
const APInput = React.lazy(() => import("./views/Finance/AP/APInput"));
const LoanPayment = React.lazy(() => import("./views/Finance/AP/LoanPayment"));
const APList = React.lazy(() => import("./views/Finance/AP/APList"));
const APUpdate = React.lazy(() => import("./views/Finance/AP/APUpdate"));
const CashFlow = React.lazy(() => import("./views/Finance/CashFlow/CashFlow"));
const PettyCash = React.lazy(() =>
  import("./views/Finance/PettyCash/PettyCash")
);
const CashPosition = React.lazy(() =>
  import("./views/Finance/CashPosition/CashPosition")
);
const LaveRequestLimit = React.lazy(() =>
  import("./views/Administrator/LeaveRequestLimit/LeaveRequestLimit")
);
const EmployeeList = React.lazy(() => import("./views/HCAdmin/EmployeeList"));
const LeaveApproval = React.lazy(() => import("./views/HCAdmin/LeaveApproval"));
const OverrideLeaveApproval = React.lazy(() =>
  import("./views/HCAdmin/Override/LeaveApproval")
);
const OverrideLoanApproval = React.lazy(() =>
  import("./views/HCAdmin/Override/LoanApproval")
);
const OverrideAdvanceApproval = React.lazy(() =>
  import("./views/HCAdmin/Override/AdvanceApproval")
);
const LeaveList = React.lazy(() => import("./views/HCAdmin/LeaveList"));
const ReimbursementApproval = React.lazy(() =>
  import("./views/HCAdmin/ReimbursementApproval")
);
const ReimbursementList = React.lazy(() =>
  import("./views/HCAdmin/ReimbursementList")
);
const LoanApproval = React.lazy(() => import("./views/HCAdmin/LoanApproval"));
const AdvanceApproval = React.lazy(() =>
  import("./views/HCAdmin/AdvanceApproval")
);
const LoanList = React.lazy(() => import("./views/HCAdmin/LoanList"));
const AdvanceList = React.lazy(() => import("./views/HCAdmin/AdvanceList"));
const ExchangePayment = React.lazy(() =>
  import("./views/Finance/AP/AdvanceList")
);
const Forecast = React.lazy(() =>
  import("./views/Administrator/Forecast/Forecast")
);
const ForecastPersonal = React.lazy(() =>
  import("./views/Forecast/ForecastPersonal")
);
const SupportingDashboard = React.lazy(() =>
  import("./views/Dashboard/Supporting/suportingDashboard")
);
const CashAdjustMent = React.lazy(() =>
  import("./views/Finance/CashPosition/cashAdjustMent")
);
const LawyerSectorMaster = React.lazy(() =>
  import("./views/Administrator/LawyerSectorMaster/LawyerSectorMaster")
);
const LawyerPracticeMaster = React.lazy(() =>
  import("./views/Administrator/LawyerPracticesMaster/LawyerPracticesMaster")
);
const TimesheetClock = React.lazy(() =>
  import("./views/Administrator/TimesheetClock/TimesheetClock")
);
const DailyLeaveAllowance = React.lazy(() =>
  import("./views/Administrator/DailyLeaveAllowance/DailyLeaveAllowance")
);
const Peakseason = React.lazy(() =>
  import("./views/Administrator/Peakseason/Peakseason")
);
const ReimbursementType = React.lazy(() =>
  import("./views/Administrator/ReimbursementType/ReimbursementType")
);
const ReimbursementRequestLimit = React.lazy(() =>
  import(
    "./views/Administrator/ReimbursementRequestLimit/ReimbursementRequestLimit"
  )
);
const MedicalInsuranceAssignment = React.lazy(() =>
  import(
    "./views/Administrator/MedicalInsuranceAssignment/MedicalInsuranceAssignment"
  )
);

const ReimbursementMedicalOverride = React.lazy(() =>
  import(
    "./views/HCAdmin/MedicalReimbursement/Override/ReimbursementMedicalList"
  )
);
const ReimbursementMedicalApproval = React.lazy(() =>
  import(
    "./views/HCAdmin/MedicalReimbursement/ReimbursementMedicalListApproval"
  )
);
const ReimbursementMedicalListAll = React.lazy(() =>
  import("./views/HCAdmin/MedicalReimbursement/MedicalInsuranceList")
);
const AttandaceList = React.lazy(() =>
  import("./views/Dashboard/HumanCapital/Attendance/Attendance")
);

const HppRegulasi = React.lazy(() =>
  import("./views/Dashboard/HppRegulasi/HppRegulasi")
);

const HppPutusan = React.lazy(() =>
  import("./views/Dashboard/HppPutusan/HppPutusan")
);

const CaseListRoutine = React.lazy(() =>
  import("./views/CasePage/CaseRoutine/RoutineList")
);

const ContractList = React.lazy(() =>
  import("./views/CasePage/Contract/ContractList")
);

const ContractCreate = React.lazy(() =>
  import("./views/CasePage/Contract/ContractCreate")
);

const TimesheetExport = React.lazy(() =>
  import("./views/Finance/TimesheetExport")
);

const UserManagement = React.lazy(() =>
  import("./views/Administrator/UserManagement/UserCreate")
);

const UserList = React.lazy(() =>
  import("./views/Administrator/UserManagement/UserList")
);

const LawyerManagement = React.lazy(() =>
  import("./views/Administrator/LawyerManagement/LawyerCreate")
);

const LawyerList = React.lazy(() =>
  import("./views/Administrator/LawyerManagement/LawyerList")
);

const AttendanceDivisions = React.lazy(() =>
  import(
    "./views/Administrator/AttendanceSettings/AttendanceDivisions/AttendanceDivision"
  )
);
const DivisionAssignment = React.lazy(() =>
  import(
    "./views/Administrator/AttendanceSettings/DivisionAssignment/DivisionAssignment"
  )
);
const MasterBank = React.lazy(() => import("./views/Administrator/MasterBank"));
const PayrollSlip = React.lazy(() => import("./views/PayrollSlip/PayrollSlip"));
const routes = [
  {
    path: "/",
    name: "Home",
  },
  {
    path: "/case_types",
    component: CaseTypeAdminPage,
    exact: true,
    name: "Master Case Type",
  },
  {
    path: "/HC/Attendance",
    component: AttandaceList,
    exact: true,
    name: "Attendance List",
  },
  {
    path: "/case_status",
    component: CaseStatusAdminPage,
    exact: true,
    name: "Master Case Status Admin",
  },
  {
    path: "/create_bank",
    component: MasterBank,
    exact: true,
    name: "Master Data Bank",
  },
  {
    path: "/leave_request_category",
    component: LeaveRequstAdminPage,
    exact: true,
    name: "Master Leave Request Category",
  },
  {
    path: "/leave/Leave_request_limit",
    component: LaveRequestLimit,
    exact: true,
    name: "Master Leave Request Limit",
  },
  {
    path: "/attendance_division/division_list",
    component: AttendanceDivisions,
    exact: true,
    name: "Attendance Divisions",
  },
  {
    path: "/attendance_division/division_assignment",
    component: DivisionAssignment,
    exact: true,
    name: "Division Assignment",
  },
  {
    path: "/reimbursement_request_limit",
    name: "Master Reimbursement Request Limit",
    exact: true,
    component: ReimbursementRequestLimit,
  },
  {
    path: "/Reimbursement",
    name: "Master Reimbursement Type",
    component: ReimbursementType,
    exact: true,
  },
  { path: "/payroll-slip", name: "Payroll Slips", component: PayrollSlip },
  {
    path: "/master/LawyerSectorMaster",
    component: LawyerSectorMaster,
    exact: true,
    name: "Master Lawyer Sector",
  },
  {
    path: "/master/LawyerPracticesMaster",
    component: LawyerPracticeMaster,
    exact: true,
    name: "Master Lawyer Practice",
  },
  {
    path: "/master/TimesheetLock",
    component: TimesheetClock,
    exact: true,
    name: "Timesheet Clock",
  },
  {
    path: "/HC/peakseason",
    component: Peakseason,
    exact: true,
    name: "Peak Season",
  },
  {
    path: "/HC/DailyleaveAllowance",
    component: DailyLeaveAllowance,
    exact: true,
    name: "Daily Leave Allowance",
  },
  {
    path: "/HC/leave_approval",
    component: LeaveApproval,
    exact: true,
    name: "Leave Approval",
  },
  {
    path: "/HC/override_leave_approval",
    component: OverrideLeaveApproval,
    exact: true,
    name: "Override Leave Approval",
  },
  {
    path: "/HC/override_loan_approval",
    component: OverrideLoanApproval,
    exact: true,
    name: "Override Loan Approval",
  },
  {
    path: "/HC/override_advance_approval",
    component: OverrideAdvanceApproval,
    exact: true,
    name: "Override Advance Approval",
  },
  {
    path: "/HC/leave_list",
    component: LeaveList,
    exact: true,
    name: "Leave List",
  },
  {
    path: "/HC/reimbursement_approval",
    component: ReimbursementApproval,
    exact: true,
    name: "Reimbursement Approval",
  },
  {
    path: "/HC/reimbursement_List",
    component: ReimbursementList,
    exact: true,
    name: "Reimbursement List",
  },
  {
    path: "/HC/reimbursement_override_approval",
    component: ReimbursementOverride,
    exact: true,
    name: "Override Reimbursement",
  },
  {
    path: "/HC/loan_approval",
    component: LoanApproval,
    exact: true,
    name: "Loan Approval",
  },
  {
    path: "/HC/advance_approval",
    component: AdvanceApproval,
    exact: true,
    name: "Advance Approval",
  },
  {
    path: "/HC/loan_List",
    component: LoanList,
    exact: true,
    name: "Loan List",
  },
  {
    path: "/HC/advance_List",
    component: AdvanceList,
    exact: true,
    name: "Advance List",
  },
  {
    path: "/exchange-payment",
    component: ExchangePayment,
    exact: true,
    name: "Exchange Payment",
  },
  {
    path: "/HC/employee_list",
    component: EmployeeList,
    exact: true,
    name: "Employee List",
  },
  {
    path: "/human_capital/med_reimbursement_plan",
    component: MedicalReimbursement,
    exact: true,
    name: "Medical Reimbursement",
  },
  {
    path: "/human_capital/medicalInsuranceAssigment",
    component: MedicalInsuranceAssignment,
    exact: true,
    name: "Medical Insurance Assignment",
  },
  {
    path: "/human_capital/med_plan/:id/edit",
    component: MedicalReimbursementPlanDetail,
    exact: true,
    name: "Medical Reimbursement Detail",
  },
  {
    path: "/matter_configurations/case_update_template",
    component: CaseUpdateTemplateMaster,
    exact: true,
    name: "Master Case Template",
  },
  {
    path: "/matter_configurations/case_flags",
    component: CaseFlagMaster,
    exact: true,
    name: "Master Case Flag",
  },
  {
    path: "/master/practices",
    component: PracticeMaster,
    exact: true,
    name: "Master Practice",
  },
  {
    path: "/master/sectors",
    component: SectorMaster,
    exact: true,
    name: "Master Sector",
  },
  {
    path: "/master/vendors",
    component: VendorMaster,
    exact: true,
    name: "Master Vendor",
  },
  {
    path: "/master/document_types",
    component: DocumentTypeMaster,
    exact: true,
    name: "Master Document Type",
  },
  {
    path: "/approvals/settings",
    name: "User Approvals",
    component: ApprovalSystem,
    exact: true,
  },

  // {
  //   path: "/HC/reimbursementMedicalList",
  //   name: "Reimbursement Medical List",
  //   component: ReimbursementMedicalList,
  // (exact: true), // },

  {
    path: "/HC/reimbursementMedicalApproval",
    name: "Reimbursement Medical Approval",
    component: ReimbursementMedicalApproval,
    exact: true,
  },

  {
    path: "/HC/reimbursement_medical_insurance_list",
    name: "Reimbursement Medical List",
    component: ReimbursementMedicalListAll,
    exact: true,
  },

  {
    path: "/HC/reimbursementMedicalOverride",
    name: "Reimbursement Medical List",
    component: ReimbursementMedicalOverride,
    exact: true,
  },

  {
    path: "/timesheet/input",
    component: TimesheetInput,
    exact: true,
    name: "Input Timesheet",
  },
  {
    path: "/timesheet/routine",
    component: TimesheetInputRoutine,
    exact: true,
    name: "Timesheet Routine",
  },
  {
    path: "/timesheet_routine_update/:id",
    name: "Timesheet Update",
    component: TimesheetRoutineUpdate,
    exact: true,
  },

  {
    path: "/Timesheet_routine",
    component: TimesheetSearchRoutine,
    exact: true,
    name: "Timesheet Routine",
  },
  {
    path: "/forecastpersonal",
    component: ForecastPersonal,
    exact: true,
    name: "Personal Forecast",
  },
  {
    path: "/forecast",
    component: Forecast,
    exact: true,
    name: "Forecast",
  },
  {
    path: "/Timesheet_search",
    component: TimesheetSearch,
    exact: true,
    name: "Search Timesheet",
  },
  {
    path: "/Timesheets/view",
    component: TimesheetsView,
    exact: true,
    name: "View Timesheet",
  },
  {
    path: "/businessdashboard",
    name: "Business Dashboard",
    component: BusinessDashboard,
    exact: true,
  },

  {
    path: "/startpage",
    name: "Welcome",
    component: WelcomePage,
    exact: true,
    name: "Welcome",
  },
  {
    path: "/welcome",
    name: "Welcome",
    component: FirstPage,
    exact: true,
    name: "Welcome",
  },
  { path: "/dashboard", name: "Common Dashboard", component: Dashboard },
  {
    exact: true,

    path: "/hppregulasi",
    name: "Hpp Regulasi",
    component: HppRegulasi,
    exact: true,
  },

  {
    path: "/hppputusan",
    name: "Hpp Putusan",
    component: HppPutusan,
    exact: true,
  },

  {
    path: "/supportingDashboard",
    component: SupportingDashboard,
    exact: true,
    name: "Supporting Dashboard",
  },
  {
    path: "/accountReceivable",
    name: "Account Receivable",
    component: AccountReceivable,
    exact: true,
  },

  {
    path: "/arlist",
    name: "Account Receivable List",
    component: ARList,
    exact: true,
  },

  {
    path: "/arinput",
    name: "Account Receivable Input",
    component: ARInput,
    exact: true,
  },

  {
    path: "/arupdate/:id",
    name: "Account Receivable",
    component: ARUpdate,
    exact: true,
  },

  {
    path: "/aplist/apupdate/:id",
    name: "Account Payable",
    component: APUpdate,
    exact: true,
  },

  {
    path: "/aplist",
    name: "Account Payable List",
    component: APList,
    exact: true,
  },

  {
    path: "/apinput",
    name: "Account Payable Input",
    component: APInput,
    exact: true,
  },

  {
    path: "/loan_payment",
    name: "Loan Payment List",
    component: LoanPayment,
    exact: true,
  },

  {
    path: "/hcdashboard",
    name: "Human Capital Dashboard",
    component: HCDashboard,
    exact: true,
  },

  {
    path: "/financedashboard",
    name: "Finance Dashboard",
    component: FinanceDashboard,
    exact: true,
  },

  {
    path: "/timesheet-export",
    name: "Timesheet Export",
    component: TimesheetExport,
    exact: true,
  },

  {
    path: "/contract-list",
    name: "Contract List",
    component: ContractList,
    exact: true,
  },

  {
    path: "/contract-management",
    name: "Contract Management",
    component: ContractCreate,
    exact: true,
  },

  {
    path: "/contract-management/:id",
    name: "Contract Management",
    component: ContractCreate,
    exact: true,
  },

  {
    path: "/cases",
    name: "Case Homepage",
    component: CaseControl,
    exact: true,
  },

  {
    path: "/case/:id/:id/detail",
    name: "Case Details",
    component: CasePage,
    exact: true,
  },

  {
    path: "/casenew",
    name: "Case New",
    component: CaseNew,
    exact: true,
  },

  {
    path: "/caseprospect",
    name: "Case Prospect",
    component: CaseProspect,
    exact: true,
  },

  {
    path: "/caseUpdate/:id/case",
    name: "Case Update",
    component: CaseUpdate,
    exact: true,
  },

  {
    path: "/prospectupdate/:id/prospect",
    name: "Prospect Update",
    component: CaseUpdateProspect,
    exact: true,
  },

  {
    path: "/profile/:id/info",
    name: "Employee Profile Information",
    component: EmployeeProfile,
    exact: true,
  },

  {
    path: "/profile/:id/notes",
    name: "Notes Detail",
    component: NotesView,
    exact: true,
  },

  {
    path: "/caseboard/:mode",
    name: "Case Board",
    component: CaseBoard,
    exact: true,
  },

  {
    path: "/caselist",
    name: "Case List",
    component: CaseList,
    exact: true,
  },

  {
    path: "/prospectlist",
    name: "Prospect List",
    component: ProspectList,
    exact: true,
  },

  {
    path: "/case/Document",
    name: "Case See DOcument",
    component: CaseSeeDocument,
    exact: true,
  },

  {
    path: "/routine_activity",
    name: "New Routine List",
    component: CaseListRoutine,
    exact: true,
  },

  {
    path: "/cashflow",
    name: "Cash Flow",
    component: CashFlow,
    exact: true,
  },

  {
    path: "/pettycash",
    name: "Petty Cash",
    component: PettyCash,
    exact: true,
  },

  {
    path: "/CashPosition",
    name: "Cash Position",
    component: CashPosition,
    exact: true,
  },

  {
    path: "/CashAdjustMent",
    name: "Cash Adjust Ment",
    component: CashAdjustMent,
    exact: true,
  },

  {
    path: "/approvals/general",
    name: "Approvals",
    component: GeneralApprovalSystem,
    exact: true,
  },

  {
    path: "/meetinglog",
    name: "Meeting Log",
    component: MeetingLog,
    exact: true,
  },

  {
    path: "/potentialclient",
    name: "Potential Client",
    component: PotentialClient,
    exact: true,
  },

  {
    path: "/timesheetUpdate/:id",
    name: "Timesheet Update",
    component: TimesheetUpdate,
    exact: true,
  },

  {
    path: "/master/user-management/",
    name: "User Management",
    component: UserManagement,
    exact: true,
  },

  {
    path: "/master/user-management/:user",
    name: "User Management",
    component: UserManagement,
    exact: true,
  },

  {
    path: "/master/user-list/",
    name: "User List",
    component: UserList,
    exact: true,
  },

  {
    path: "/master/member-management/",
    name: "Active Member Management",
    component: LawyerManagement,
    exact: true,
  },

  {
    path: "/master/member-management/:lawyer",
    name: "Member Management",
    component: LawyerManagement,
    exact: true,
  },

  {
    path: "/master/member-list/",
    name: "Member List",
    component: LawyerList,
    exact: true,
  },

  {
    path: "/theme",
    name: "Theme",
    component: Colors,
    exact: true,
  },

  {
    path: "/theme/colors",
    name: "Colors",
    component: Colors,
    exact: true,
  },

  {
    path: "/theme/typography",
    name: "Typography",
    component: Typography,
    exact: true,
  },

  {
    path: "/base",
    name: "Base",
    component: Cards,
    exact: true,
  },

  {
    path: "/base/cards",
    name: "Cards",
    component: Cards,
    exact: true,
  },

  {
    path: "/base/forms",
    name: "Forms",
    component: Forms,
    exact: true,
  },

  {
    path: "/base/switches",
    name: "Switches",
    component: Switches,
    exact: true,
  },

  {
    path: "/base/tables",
    name: "Tables",
    component: Tables,
    exact: true,
  },

  {
    path: "/base/tabs",
    name: "Tabs",
    component: Tabs,
    exact: true,
  },

  {
    path: "/base/breadcrumbs",
    name: "Breadcrumbs",
    component: Breadcrumbs,
    exact: true,
  },

  {
    path: "/base/carousels",
    name: "Carousel",
    component: Carousels,
    exact: true,
  },

  {
    path: "/base/collapses",
    name: "Collapse",
    component: Collapses,
    exact: true,
  },

  {
    path: "/base/dropdowns",
    name: "Dropdowns",
    component: Dropdowns,
    exact: true,
  },

  {
    path: "/base/jumbotrons",
    name: "Jumbotrons",
    component: Jumbotrons,
    exact: true,
  },

  {
    path: "/base/list-groups",
    name: "List Groups",
    component: ListGroups,
    exact: true,
  },

  {
    path: "/base/navbars",
    name: "Navbars",
    component: Navbars,
    exact: true,
  },

  {
    path: "/base/navs",
    name: "Navs",
    component: Navs,
    exact: true,
  },

  {
    path: "/base/paginations",
    name: "Paginations",
    component: Paginations,
    exact: true,
  },

  {
    path: "/base/popovers",
    name: "Popovers",
    component: Popovers,
    exact: true,
  },

  {
    path: "/base/progress-bar",
    name: "Progress Bar",
    component: ProgressBar,
    exact: true,
  },

  {
    path: "/base/tooltips",
    name: "Tooltips",
    component: Tooltips,
    exact: true,
  },

  {
    path: "/buttons",
    name: "Buttons",
    component: Buttons,
    exact: true,
  },

  {
    path: "/buttons/buttons",
    name: "Buttons",
    component: Buttons,
    exact: true,
  },

  {
    path: "/buttons/button-dropdowns",
    name: "Button Dropdowns",
    component: ButtonDropdowns,
    exact: true,
  },

  {
    path: "/buttons/button-groups",
    name: "Button Groups",
    component: ButtonGroups,
    exact: true,
  },

  {
    path: "/buttons/brand-buttons",
    name: "Brand Buttons",
    component: BrandButtons,
    exact: true,
  },

  {
    path: "/icons",
    name: "Icons",
    component: CoreUIIcons,
    exact: true,
  },

  {
    path: "/icons/coreui-icons",
    name: "CoreUI Icons",
    component: CoreUIIcons,
    exact: true,
  },

  {
    path: "/icons/flags",
    name: "Flags",
    component: Flags,
    exact: true,
  },

  {
    path: "/icons/font-awesome",
    name: "Font Awesome",
    component: FontAwesome,
    exact: true,
  },

  {
    path: "/icons/simple-line-icons",
    name: "Simple Line Icons",
    component: SimpleLineIcons,
    exact: true,
  },

  {
    path: "/notifications",
    name: "Notifications",
    component: Alerts,
    exact: true,
  },

  {
    path: "/notifications/alerts",
    name: "Alerts",
    component: Alerts,
    exact: true,
  },

  {
    path: "/notifications/badges",
    name: "Badges",
    component: Badges,
    exact: true,
  },

  {
    path: "/notifications/modals",
    name: "Modals",
    component: Modals,
    exact: true,
  },

  {
    path: "/widgets",
    name: "Widgets",
    component: Widgets,
    exact: true,
  },

  {
    path: "/charts",
    name: "Charts",
    component: Charts,
    exact: true,
  },

  {
    path: "/users",
    name: "Users",
    component: Users,
    exact: true,
  },
  {
    path: "/users/:id",
    name: "User Details",
    component: User,
    exact: true,
  },
];

export default routes;
